'use strict';

class Filter {
  open() {
    window.dropdowns.forEach(element => {
      element.close();
    });

    this.active = true;
    this.el.addClass('active');
    this.target.slideDown();
  }
  close() {
    this.active = false;
    this.el.removeClass('active');
    this.target.slideUp();
  }

  constructor(el) {
    this.active = false;
    this.el = $(el);
    this.target = $('.dropdown-' + this.el.data('dropdown'));

    this.el.click(() => {
      if (this.active) {
        this.close();
      } else {
        this.open();
      }
    });
    window.dropdowns = window.dropdowns || [];
    window.dropdowns.push(this);
  }
}

class Accordion {
  constructor(el) {
    this.el = $(el);
    this.items = this.el.find('.item');

    this.items.each((i, el) => {
      $(el).find('.trigger').click(() => {
        this.activate(i);
      });
    });

    this.activate(0);
  }

  activate(index) {
    this.items.each((i, el) => {
      if (index === i) {
        $(el).find('.content').slideDown();
        this.el.find(`.item-image[data-index="${i}"]`).addClass('active');
      } else {
        $(el).find('.content').slideUp();
        this.el.find(`.item-image[data-index="${i}"]`).removeClass('active');
      }
    });
  }
}

class Lists {
  constructor(el) {
    this.el = $(el);
    this.items = this.el.find('.item');
  }
}

class Drawer {
  constructor(el, group) {
    this.el = $(el);
    this.group = group;
    this.trigger = this.el.find('.trigger');
    this.contents = this.el.find('.contents');
    this.isOpen = false;

    this.trigger.click(() => {
      for (let d of this.group) {
        if (d != this) {
          d.close();
        }
      }
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    });
  }

  toggle() {
    this.contents.slideToggle();
  }

  open() {
    this.isOpen = true;
    this.el.removeClass('active inactive').addClass('active');
    this.contents.slideDown();
    $('html').addClass('drawer-open');
  }

  close() {
    this.isOpen = false;
    this.el.removeClass('active inactive').addClass('inactive');
    this.contents.slideUp();
    $('html').removeClass('drawer-open');
  }
}

module.exports = {
  Accordion,
  Lists,
  Filter,
  Drawer
};